import React, { useState, useEffect } from 'react'

import Navbar from '../../Components/Navbar/Navbar'
import { 
    Layout,
    Col, 
    Row,
    Table,
    Space,
    Button,
    Tabs
} from 'antd';

import { UseGetRequest } from '../../Utils/api/ApiRequests'
// import { usePostRequest } from '../../hooks/usePostRequest'
// import { formatDate } from '../../Utils/Common';
import { 
  ProductOutlined 
} from '@ant-design/icons';
import { 
  ArrowBack,
} from '@mui/icons-material';
import { 
  useNavigate, 
  useParams 
} from "react-router-dom"
import toast from 'react-hot-toast';

const { TabPane } = Tabs;

const InvitationalViewSummary = () => {
  const navigate = useNavigate()
  const { id } = useParams()
  // const [isLoading, setIsLoading] = useState(false);
  // const [pageSize, setPageSize] = useState('');

  const [filterConfig, setFilterConfig] = useState({
    tournament_id: id,
    directors_cup_player_id: '',
    day: "1",
    // employee_id: '',
    // page: 1,
  })
  const [isLoading, setIsLoading] = useState(false);
  const [summaryData, setSummaryData] = useState([])
  // const [excelLink, setExcelLink] = useState('')

  const customSpinner = <ProductOutlined style={{ fontSize: 24 }} spin />;

  async function fetchPlayerData() {
    setIsLoading(true)
    const response = await UseGetRequest("invitational_scores/get_score_summary", filterConfig);
    if (response?.data) {
      setSummaryData(response?.data?.summaries);
    } else {
      setSummaryData([])
    }

    setIsLoading(false);
  }

  async function fetchExportExcel() {
    setIsLoading(true)
    const response = await UseGetRequest("invitational_scores/get_excel_report", {tournament_id: id});
    if (response?.data) {
      const link = document.createElement('a');
      link.href = response.data.url;
      link.setAttribute('download', 'file.xlsx'); // You can specify the file name
      document.body.appendChild(link);
      link.click();
      link.remove();
    } else {
      toast.error(response?.data?.message)
    }
    setIsLoading(false);
  }

  const columns = [
    {
      title: 'TEAM',
      dataIndex: 'team_name',
      key: 'team_name',
      align: 'center',
      width: '25vw',
    },
    {
      title: 'PLAYER',
      dataIndex: 'player_name',
      key: 'player_name',
      align: 'center',
      width: '25vw',
      render: (_, record) => (
        <>
          {record?.players?.map((data, index) => (
            <div key={index}>
              {data.name}
            </div>
          ))}
        </>
      ),
    },
    // {
    //   title: 'HDC',
    //   dataIndex: 'hdc',
    //   key: 'hdc',
    //   align: 'center',
    //   render: (_, record) => (
    //     <>
    //       {record?.players?.map((data, index) => (
    //         <div key={index}>
    //           {data.hdc}
    //         </div>
    //       ))}
    //     </>
    //   ),
    // },
    // {
    //   title: 'TOTAL HDC',
    //   dataIndex: 'total_hdc',
    //   key: 'total_hdc',
    //   align: 'center',
    // },
    {
      title: 'DIVISION',
      dataIndex: 'division_name',
      key: 'division_name',
      align: 'center',
    },
    {
      title: 'OUT',
      dataIndex: 'gs_out',
      key: 'gs_out',
      align: 'center',
      render: (_, record) => (
        <>
          {record?.players?.map((data, index) => (
            <div key={index}>
              {data.gs_out}
            </div>
          ))}
        </>
      ),
    },
    {
      title: 'IN',
      dataIndex: 'gs_in',
      key: 'gs_in',
      align: 'center',
      render: (_, record) => (
        <>
          {record?.players?.map((data, index) => (
            <div key={index}>
              {data.gs_in}
            </div>
          ))}
        </>
      ),
    },
    {
      title: 'GROSS SCORES',
      dataIndex: 'gross',
      key: 'gross',
      align: 'center',
      onHeaderCell: () => ({
        style: { backgroundColor: 'rgb(210, 241, 210)' },
      }),
      render: (_, record) => (
        <>
          {record?.players?.map((data, index) => (
            <div key={index}>
              {data.gross}
            </div>
          ))}
        </>
      ),
    },
        {
      title: 'OUT',
      dataIndex: 'gp_out',
      key: 'gp_out',
      align: 'center',
      render: (_, record) => (
        <>
          {record?.players?.map((data, index) => (
            <div key={index}>
              {data.gp_out}
            </div>
          ))}
        </>
      ),
    },
    {
      title: 'IN',
      dataIndex: 'gp_in',
      key: 'gp_in',
      align: 'center',
      render: (_, record) => (
        <>
          {record?.players?.map((data, index) => (
            <div key={index}>
              {data.gp_in}
            </div>
          ))}
        </>
      ),
    },
    {
      title: 'GROSS POINTS',
      dataIndex: 'gross_points',
      key: 'gross_points',
      align: 'center',
      onHeaderCell: () => ({
        style: { backgroundColor: 'rgb(210, 230, 255)' },
      }),
      render: (_, record) => (
        <>
          {record?.players?.map((data, index) => (
            <div key={index}>
              {data.gross_points}
            </div>
          ))}
        </>
      ),
    },
    {
      title: 'OUT',
      dataIndex: 'ns_out',
      key: 'ns_out',
      align: 'center',
      render: (_, record) => (
        <>
          {record?.players?.map((data, index) => (
            <div key={index}>
              {data.ns_out}
            </div>
          ))}
        </>
      ),
    },
    {
      title: 'IN',
      dataIndex: 'ns_in',
      key: 'ns_in',
      align: 'center',
      render: (_, record) => (
        <>
          {record?.players?.map((data, index) => (
            <div key={index}>
              {data.ns_in}
            </div>
          ))}
        </>
      ),
    },
    {
      title: 'NET SCORES',
      dataIndex: 'net',
      key: 'net',
      align: 'center',
      onHeaderCell: () => ({
        style: { backgroundColor: 'rgb(241, 222, 207)' },
      }),
      render: (_, record) => (
        <>
          {record?.players?.map((data, index) => (
            <div key={index}>
              {data.net}
            </div>
          ))}
        </>
      ),
    },
        {
      title: 'OUT',
      dataIndex: 'np_out',
      key: 'np_out',
      align: 'center',
      render: (_, record) => (
        <>
          {record?.players?.map((data, index) => (
            <div key={index}>
              {data.np_out}
            </div>
          ))}
        </>
      ),
    },
    {
      title: 'IN',
      dataIndex: 'np_in',
      key: 'np_in',
      align: 'center',
      render: (_, record) => (
        <>
          {record?.players?.map((data, index) => (
            <div key={index}>
              {data.np_in}
            </div>
          ))}
        </>
      ),
    },
    {
      title: 'NET POINTS',
      dataIndex: 'net_points',
      key: 'net_points',
      align: 'center',
      onHeaderCell: () => ({
        style: { backgroundColor: 'rgb(231, 210, 241) ' },
      }),
      render: (_, record) => (
        <>
          {record?.players?.map((data, index) => (
            <div key={index}>
              {data.net_points}
            </div>
          ))}
        </>
      ),
    },
    {
      title: 'TOTAL GROSS POINTS',
      dataIndex: 'total_gross_points',
      key: 'total_gross_points',
      align: 'center',
    },
    {
      title: 'TOTAL NET POINTS',
      dataIndex: 'total_net_points',
      key: 'total_net_points',
      align: 'center',
    },
  ];

  const handleTableChange = (pagination) => {
    setFilterConfig((prev) => ({
      ...prev,
      page: parseInt(pagination.current),
      // total_records_per_page: pagination.pageSize,
    }));
  };

  const onChange = (activeKey) => {
    setFilterConfig((prev) => (
      {
        ...prev,
        day:  activeKey
      }
    ));
  };
  console.log(summaryData)
  useEffect(() => {
    fetchPlayerData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterConfig]);

  return (
    <Layout className='page'>
      <Navbar navKey={'three_to_count_nav'}/>
      <Layout className='content-container overflow-y'>
        <Row className='custom-padding responsive-tab-inline'>
          <Col span={12} >
            <Space className='header-container'>
              <ArrowBack className='cursor' onClick={() => navigate('/invitational/player/' + id)}/>
              SUMMARY
            </Space>
          </Col>
          <Col span={12} align='right' className='p-2'>
            <Button 
              className='excel-btn' 
              size="large"
              onClick={fetchExportExcel}
            >
              Export To Excel
            </Button>
          </Col>
        </Row>
        <Row className='page-content'>
          <Col span={24} className='responsive-overflow-auto'>
            <Tabs 
              defaultActiveKey="all" 
              type="card" 
              activeKey={filterConfig?.day}
              className="custom-tabs"
              onChange={onChange}
            >
              <TabPane tab="Day 1" key="1">
                <Table 
                  columns={columns} 
                  dataSource={summaryData} 
                  loading={{
                    indicator: customSpinner,
                    spinning: isLoading,
                  }}
                  pagination={false}
                  onChange={handleTableChange}
                  rowClassName='fourman-table'
                  className='fourman-summary-table'
                  // onRow={(record, rowIndex) => {
                  //   return {
                  //     className: 'cursor',
                  //     onClick: () => navigate('/fourman/player/' + record.id),
                  //   };
                  // }}
                />
              </TabPane>
              <TabPane tab="Day 2" key="2">
                <Table 
                  columns={columns} 
                  dataSource={summaryData} 
                  loading={{
                    indicator: customSpinner,
                    spinning: isLoading,
                  }}
                  pagination={false}
                  onChange={handleTableChange}
                  rowClassName='fourman-table'
                  className='fourman-summary-table'
                  // onRow={(record, rowIndex) => {
                  //   return {
                  //     className: 'cursor',
                  //     onClick: () => navigate('/fourman/player/' + record.id),
                  //   };
                  // }}
                />
              </TabPane>
            </Tabs>
          </Col>
        </Row>
      </Layout>
    </Layout>
  )
}

export default InvitationalViewSummary
